import React, { useState, useCallback, useMemo, forwardRef, useImperativeHandle } from 'react';
import AntLocalization from '../../utils/AntLocalization';
import AntCondition from '../../utils/AntCondition';
import './index.scss';

var t = function (obj) { return AntLocalization.translateText(obj); };

// ─── Operator definitions ────────────────────────────────────────
var OPERATORS = {
    string: [
        { value: '=', label: { vi: 'Bằng', en: 'Equals', fr: 'Égal à', es: 'Igual a', id: 'Sama', ja: '等しい', zh: '等于', ko: '같음', hi: 'बराबर', ar: 'يساوي' } },
        { value: '!=', label: { vi: 'Khác', en: 'Not equals', fr: 'Différent de', es: 'Distinto de', id: 'Tidak sama', ja: '等しくない', zh: '不等于', ko: '같지 않음', hi: 'बराबर नहीं', ar: 'لا يساوي' } },
        { value: 'contains', label: { vi: 'Chứa', en: 'Contains', fr: 'Contient', es: 'Contiene', id: 'Berisi', ja: '含む', zh: '包含', ko: '포함', hi: 'शामिल', ar: 'يحتوي' } },
        { value: 'in', label: { vi: 'Thuộc', en: 'In list', fr: 'Parmi', es: 'En lista', id: 'Di daftar', ja: 'いずれか', zh: '属于', ko: '목록 내', hi: 'सूची में', ar: 'ضمن' } },
        { value: 'IsNull', label: { vi: 'Trống', en: 'Is empty', fr: 'Vide', es: 'Vacío', id: 'Kosong', ja: '空', zh: '为空', ko: '비어 있음', hi: 'खाली', ar: 'فارغ' } },
        { value: 'NotNull', label: { vi: 'Có giá trị', en: 'Not empty', fr: 'Non vide', es: 'No vacío', id: 'Tidak kosong', ja: '空でない', zh: '不为空', ko: '값 있음', hi: 'खाली नहीं', ar: 'غير فارغ' } }
    ],
    number: [
        { value: '=', label: { vi: 'Bằng', en: 'Equals', fr: 'Égal à', es: 'Igual a', id: 'Sama', ja: '等しい', zh: '等于', ko: '같음', hi: 'बराबर', ar: 'يساوي' } },
        { value: '!=', label: { vi: 'Khác', en: 'Not equals', fr: 'Différent de', es: 'Distinto de', id: 'Tidak sama', ja: '等しくない', zh: '不等于', ko: '같지 않음', hi: 'बराबर नहीं', ar: 'لا يساوي' } },
        { value: '>', label: { vi: 'Lớn hơn', en: 'Greater than', fr: 'Supérieur à', es: 'Mayor que', id: 'Lebih dari', ja: 'より大きい', zh: '大于', ko: '초과', hi: 'से अधिक', ar: 'أكبر من' } },
        { value: '>=', label: { vi: 'Lớn hơn hoặc bằng', en: 'Greater or equal', fr: 'Supérieur ou égal', es: 'Mayor o igual', id: 'Lebih dari/sama', ja: '以上', zh: '大于等于', ko: '이상', hi: 'अधिक या बराबर', ar: 'أكبر أو يساوي' } },
        { value: '<', label: { vi: 'Nhỏ hơn', en: 'Less than', fr: 'Inférieur à', es: 'Menor que', id: 'Kurang dari', ja: 'より小さい', zh: '小于', ko: '미만', hi: 'से कम', ar: 'أصغر من' } },
        { value: '<=', label: { vi: 'Nhỏ hơn hoặc bằng', en: 'Less or equal', fr: 'Inférieur ou égal', es: 'Menor o igual', id: 'Kurang dari/sama', ja: '以下', zh: '小于等于', ko: '이하', hi: 'कम या बराबर', ar: 'أصغر أو يساوي' } },
        { value: 'IsNull', label: { vi: 'Trống', en: 'Is empty', fr: 'Vide', es: 'Vacío', id: 'Kosong', ja: '空', zh: '为空', ko: '비어 있음', hi: 'खाली', ar: 'فارغ' } },
        { value: 'NotNull', label: { vi: 'Có giá trị', en: 'Not empty', fr: 'Non vide', es: 'No vacío', id: 'Tidak kosong', ja: '空でない', zh: '不为空', ko: '값 있음', hi: 'खाली नहीं', ar: 'غير فارغ' } }
    ],
    date: [
        { value: '=', label: { vi: 'Bằng', en: 'Equals', fr: 'Égal à', es: 'Igual a', id: 'Sama', ja: '等しい', zh: '等于', ko: '같음', hi: 'बराबर', ar: 'يساوي' } },
        { value: '>', label: { vi: 'Sau', en: 'After', fr: 'Après', es: 'Después', id: 'Setelah', ja: 'より後', zh: '晚于', ko: '이후', hi: 'के बाद', ar: 'بعد' } },
        { value: '<', label: { vi: 'Trước', en: 'Before', fr: 'Avant', es: 'Antes', id: 'Sebelum', ja: 'より前', zh: '早于', ko: '이전', hi: 'से पहले', ar: 'قبل' } },
        { value: 'lastSeconds', label: { vi: 'Trong vòng (giây)', en: 'Within (seconds)', fr: 'Depuis moins de (s)', es: 'Hace menos de (s)', id: 'Dalam (detik)', ja: '以内（秒）', zh: '之内（秒）', ko: '이내 (초)', hi: 'भीतर (सेकंड)', ar: 'خلال (ثوانٍ)' } },
        { value: 'afterSeconds', label: { vi: 'Quá (giây)', en: 'After (seconds)', fr: 'Depuis plus de (s)', es: 'Hace más de (s)', id: 'Lebih dari (detik)', ja: '経過（秒）', zh: '超过（秒）', ko: '경과 (초)', hi: 'बाद (सेकंड)', ar: 'بعد (ثوانٍ)' } },
        { value: 'IsNull', label: { vi: 'Trống', en: 'Is empty', fr: 'Vide', es: 'Vacío', id: 'Kosong', ja: '空', zh: '为空', ko: '비어 있음', hi: 'खाली', ar: 'فارغ' } },
        { value: 'NotNull', label: { vi: 'Có giá trị', en: 'Not empty', fr: 'Non vide', es: 'No vacío', id: 'Tidak kosong', ja: '空でない', zh: '不为空', ko: '값 있음', hi: 'खाली नहीं', ar: 'غير فارغ' } }
    ],
    bool: [
        { value: '=', label: { vi: 'Bằng', en: 'Equals', fr: 'Égal à', es: 'Igual a', id: 'Sama', ja: '等しい', zh: '等于', ko: '같음', hi: 'बराबर', ar: 'يساوي' } }
    ],
    Array: [
        { value: 'includes', label: { vi: 'Chứa', en: 'Includes', fr: 'Contient', es: 'Contiene', id: 'Berisi', ja: '含む', zh: '包含', ko: '포함', hi: 'शामिल', ar: 'يحتوي' } },
        { value: 'IsNull', label: { vi: 'Trống', en: 'Is empty', fr: 'Vide', es: 'Vacío', id: 'Kosong', ja: '空', zh: '为空', ko: '비어 있음', hi: 'खाली', ar: 'فارغ' } },
        { value: 'NotNull', label: { vi: 'Có giá trị', en: 'Not empty', fr: 'Non vide', es: 'No vacío', id: 'Tidak kosong', ja: '空でない', zh: '不为空', ko: '값 있음', hi: 'खाली नहीं', ar: 'غير فارغ' } }
    ]
};

var NO_VALUE_OPS = ['IsNull', 'NotNull', 'IsNullOrEmpty', 'NotNullAndEmpty'];

// ─── Generate unique ID ──────────────────────────────────────────
var _ruleIdCounter = 0;
function genId() { return 'rule_' + (++_ruleIdCounter) + '_' + Date.now(); }

// ─── Default empty rule ──────────────────────────────────────────
function createRule() {
    return { id: genId(), field: '', operator: '=', value: '' };
}

function createGroup(type) {
    return { id: genId(), type: type || 'AND', rules: [createRule()] };
}

// ─── Mock fields for demo ────────────────────────────────────────
var MOCK_FIELDS = [
    { dataField: 'loyalty_level', label: { vi: 'Cấp bậc', en: 'Loyalty Level', fr: 'Niveau fidélité', es: 'Nivel de lealtad', id: 'Level loyalitas', ja: '会員ランク', zh: '会员等级', ko: '회원 등급', hi: 'लॉयल्टी स्तर', ar: 'مستوى الولاء' }, dataType: 'string', values: [{ code: 'Silver' }, { code: 'Gold' }, { code: 'Platinum' }, { code: 'Diamond' }] },
    { dataField: 'total_purchase_amt', label: { vi: 'Tổng mua hàng', en: 'Total Purchase', fr: 'Total des achats', es: 'Total de compras', id: 'Total pembelian', ja: '購入総額', zh: '累计消费', ko: '총 구매액', hi: 'कुल खरीद', ar: 'إجمالي الشراء' }, dataType: 'number' },
    { dataField: 'entity_birthday', label: { vi: 'Ngày sinh', en: 'Birthday', fr: 'Naissance', es: 'Nacimiento', id: 'Tgl lahir', ja: '生年月日', zh: '生日', ko: '생일', hi: 'जन्मदिन', ar: 'الميلاد' }, dataType: 'date' },
    { dataField: 'adm1_code', label: { vi: 'Tỉnh/TP', en: 'Province', fr: 'Province', es: 'Provincia', id: 'Provinsi', ja: '都道府県', zh: '省/市', ko: '시/도', hi: 'प्रांत', ar: 'المحافظة' }, dataType: 'string' },
    { dataField: 'entity_gender', label: { vi: 'Giới tính', en: 'Gender', fr: 'Sexe', es: 'Género', id: 'Gender', ja: '性別', zh: '性别', ko: '성별', hi: 'लिंग', ar: 'الجنس' }, dataType: 'string', values: [{ code: 'Male', name: { vi: 'Nam', en: 'Male', fr: 'Homme', es: 'Hombre', id: 'Pria', ja: '男性', zh: '男', ko: '남성', hi: 'पुरुष', ar: 'ذكر' } }, { code: 'Female', name: { vi: 'Nữ', en: 'Female', fr: 'Femme', es: 'Mujer', id: 'Wanita', ja: '女性', zh: '女', ko: '여성', hi: 'महिला', ar: 'أنثى' } }] },
    { dataField: 'tags', label: { vi: 'Nhãn', en: 'Tags', id: 'Label', ja: 'タグ', zh: '标签', ko: '태그', hi: 'टैग', ar: 'الوسوم', fr: 'Tags', es: 'Tags' }, dataType: 'Array' },
    { dataField: 'is_active', label: { vi: 'Đang hoạt động', en: 'Active', fr: 'Actif', es: 'Activo', id: 'Aktif', ja: 'アクティブ', zh: '使用中', ko: '활성', hi: 'सक्रिय', ar: 'نشط' }, dataType: 'bool' },
    { dataField: 'last_order_date', label: { vi: 'Ngày mua cuối', en: 'Last Order Date', fr: 'Dernier achat', es: 'Última compra', id: 'Pembelian terakhir', ja: '最終購入日', zh: '最近购买日', ko: '최근 구매일', hi: 'अंतिम खरीद', ar: 'آخر شراء' }, dataType: 'date' },
    { dataField: 'feedback_count', label: { vi: 'Số phản hồi', en: 'Feedback Count', fr: 'Nombre d\'avis', es: 'N.º de opiniones', id: 'Jumlah ulasan', ja: 'フィードバック数', zh: '反馈数', ko: '피드백 수', hi: 'फ़ीडबैक संख्या', ar: 'عدد الآراء' }, dataType: 'number' },
    { dataField: 'avg_nps_score', label: { vi: 'Điểm NPS TB', en: 'Avg NPS Score', fr: 'NPS moyen', es: 'NPS medio', id: 'Rata-rata NPS', ja: '平均NPS', zh: '平均NPS', ko: '평균 NPS', hi: 'औसत NPS', ar: 'متوسط NPS' }, dataType: 'number' }
];

// ─── Mock initial rules ──────────────────────────────────────────
var MOCK_RULES = [
    {
        id: 'g1', type: 'AND', rules: [
            { id: 'r1', field: 'loyalty_level', operator: 'in', value: 'Gold,Platinum,Diamond' },
            { id: 'r2', field: 'total_purchase_amt', operator: '>', value: '10000000' }
        ]
    },
    {
        id: 'g2', type: 'OR', rules: [
            { id: 'r3', field: 'adm1_code', operator: '=', value: 'HCM' },
            { id: 'r4', field: 'adm1_code', operator: '=', value: 'HN' }
        ]
    }
];

// ─── Single Rule Row ─────────────────────────────────────────────
function RuleRow({ rule, fields, onChange, onRemove, readOnly }) {
    var fieldConfig = fields.find(function (f) { return f.dataField === rule.field; });
    var dataType = fieldConfig ? (fieldConfig.dataType || 'string') : 'string';
    var operators = OPERATORS[dataType] || OPERATORS.string;
    var needsValue = !NO_VALUE_OPS.includes(rule.operator);
    var hasValues = fieldConfig && fieldConfig.values && fieldConfig.values.length > 0;

    var handleChange = function (key, val) {
        var updated = { ...rule };
        updated[key] = val;
        // Reset operator/value when field changes
        if (key === 'field') {
            var newFieldConfig = fields.find(function (f) { return f.dataField === val; });
            var newType = newFieldConfig ? (newFieldConfig.dataType || 'string') : 'string';
            var newOps = OPERATORS[newType] || OPERATORS.string;
            if (!newOps.find(function (o) { return o.value === updated.operator; })) {
                updated.operator = newOps[0].value;
            }
            updated.value = '';
        }
        if (key === 'operator' && NO_VALUE_OPS.includes(val)) {
            updated.value = '';
        }
        onChange(updated);
    };

    return (
        <div className="rule-row">
            {/* Field picker */}
            <select
                className="rule-select rule-field"
                value={rule.field}
                onChange={function (e) { handleChange('field', e.target.value); }}
                disabled={readOnly}
            >
                <option value="">{t({ vi: '— Chọn trường —', en: '— Select field —', fr: '— Choisir champ —', es: '— Elegir campo —', id: '— Pilih kolom —', ja: '— 項目を選択 —', zh: '— 选择字段 —', ko: '— 필드 선택 —', hi: '— फ़ील्ड चुनें —', ar: '— اختر الحقل —' })}</option>
                {fields.map(function (f) {
                    var label = typeof f.label === 'object' ? t(f.label) : (f.label || f.dataField);
                    return <option key={f.dataField} value={f.dataField}>{label}</option>;
                })}
            </select>

            {/* Operator */}
            <select
                className="rule-select rule-operator"
                value={rule.operator}
                onChange={function (e) { handleChange('operator', e.target.value); }}
                disabled={readOnly}
            >
                {operators.map(function (op) {
                    return <option key={op.value} value={op.value}>{t(op.label)}</option>;
                })}
            </select>

            {/* Value */}
            {needsValue && (
                hasValues ? (
                    <select
                        className="rule-select rule-value"
                        value={rule.value}
                        onChange={function (e) { handleChange('value', e.target.value); }}
                        disabled={readOnly}
                    >
                        <option value="">{t({ vi: '— Chọn —', en: '— Select —', fr: '— Choisir —', es: '— Elegir —', id: '— Pilih —', ja: '— 選択 —', zh: '— 选择 —', ko: '— 선택 —', hi: '— चुनें —', ar: '— اختر —' })}</option>
                        {fieldConfig.values.map(function (v) {
                            var code = v.code || v;
                            var name = v.name ? (typeof v.name === 'object' ? t(v.name) : v.name) : code;
                            return <option key={code} value={code}>{name}</option>;
                        })}
                    </select>
                ) : (
                    <input
                        className="rule-input rule-value"
                        type={dataType === 'number' ? 'number' : dataType === 'date' ? 'date' : 'text'}
                        value={rule.value}
                        onChange={function (e) { handleChange('value', e.target.value); }}
                        placeholder={rule.operator === 'in' ? t({ vi: 'Giá trị 1, Giá trị 2', en: 'Value1, Value2', fr: 'Valeur 1, Valeur 2', es: 'Valor 1, Valor 2', id: 'Nilai 1, Nilai 2', ja: '値1, 値2', zh: '值1, 值2', ko: '값1, 값2', hi: 'मान 1, मान 2', ar: 'قيمة 1, قيمة 2' }) : ''}
                        disabled={readOnly}
                    />
                )
            )}
            {!needsValue && <span className="rule-no-value" />}

            {/* Remove */}
            {!readOnly && (
                <button className="rule-remove" onClick={onRemove} title={t({ vi: 'Xoá', en: 'Remove', fr: 'Retirer', es: 'Quitar', id: 'Hapus', ja: '削除', zh: '删除', ko: '삭제', hi: 'हटाएँ', ar: 'حذف' })}>
                    <i className="dx-icon-trash" />
                </button>
            )}
        </div>
    );
}

// ─── Rule Group ──────────────────────────────────────────────────
function RuleGroup({ group, fields, onChange, onRemove, readOnly, level }) {
    var handleTypeChange = function (newType) {
        onChange({ ...group, type: newType });
    };

    var handleRuleChange = function (index, updatedRule) {
        var newRules = group.rules.slice();
        newRules[index] = updatedRule;
        onChange({ ...group, rules: newRules });
    };

    var handleRuleRemove = function (index) {
        var newRules = group.rules.filter(function (_, i) { return i !== index; });
        if (newRules.length === 0) {
            if (onRemove) onRemove();
            return;
        }
        onChange({ ...group, rules: newRules });
    };

    var handleAddRule = function () {
        onChange({ ...group, rules: group.rules.concat([createRule()]) });
    };

    return (
        <div className={'rule-group level-' + (level || 0)}>
            <div className="group-header">
                <div className="group-type-toggle">
                    <button
                        className={'type-btn' + (group.type === 'AND' ? ' active' : '')}
                        onClick={function () { if (!readOnly) handleTypeChange('AND'); }}
                        disabled={readOnly}
                    >
                        AND
                    </button>
                    <button
                        className={'type-btn' + (group.type === 'OR' ? ' active' : '')}
                        onClick={function () { if (!readOnly) handleTypeChange('OR'); }}
                        disabled={readOnly}
                    >
                        OR
                    </button>
                </div>
                <div className="group-actions">
                    {!readOnly && (
                        <button className="group-add-btn" onClick={handleAddRule}>
                            + {t({ vi: 'Điều kiện', en: 'Condition', fr: 'Condition', es: 'Condición', id: 'Kondisi', ja: '条件', zh: '条件', ko: '조건', hi: 'शर्त', ar: 'شرط' })}
                        </button>
                    )}
                    {!readOnly && level > 0 && onRemove && (
                        <button className="group-remove-btn" onClick={onRemove} title={t({ vi: 'Xoá nhóm', en: 'Remove group', fr: 'Retirer groupe', es: 'Quitar grupo', id: 'Hapus grup', ja: 'グループ削除', zh: '删除组', ko: '그룹 삭제', hi: 'समूह हटाएँ', ar: 'حذف المجموعة' })}>
                            <i className="dx-icon-trash" />
                        </button>
                    )}
                </div>
            </div>
            <div className="group-rules">
                {group.rules.map(function (rule, i) {
                    return (
                        <div key={rule.id} className="group-rule-item">
                            {i > 0 && <span className="rule-connector">{group.type}</span>}
                            <RuleRow
                                rule={rule}
                                fields={fields}
                                onChange={function (updated) { handleRuleChange(i, updated); }}
                                onRemove={function () { handleRuleRemove(i); }}
                                readOnly={readOnly}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

// ═════════════════════════════════════════════════════════════════
// ─── MAIN COMPONENT ─────────────────────────────────────────────
// ═════════════════════════════════════════════════════════════════
export default forwardRef(function AntRuleBuilder(props, ref) {
    var {
        value: valueProp,
        onChange,
        fields: fieldsProp,
        readOnly = false,
        maxGroups = 10,
        maxRulesPerGroup = 10,
        mockMode = false,
        visible, session,
        title,
        showPreview = false,
        compact = false
    } = props;

    var fields = fieldsProp || (mockMode ? MOCK_FIELDS : []);

    var [groups, setGroups] = useState(function () {
        if (mockMode) return MOCK_RULES;
        if (valueProp && Array.isArray(valueProp)) return valueProp;
        if (valueProp && typeof valueProp === 'object') return [valueProp];
        return [createGroup('AND')];
    });

    // Sync external value changes
    var handleGroupsChange = useCallback(function (newGroups) {
        setGroups(newGroups);
        if (onChange) onChange(newGroups);
    }, [onChange]);

    var handleGroupChange = useCallback(function (index, updatedGroup) {
        var newGroups = groups.slice();
        newGroups[index] = updatedGroup;
        handleGroupsChange(newGroups);
    }, [groups, handleGroupsChange]);

    var handleGroupRemove = useCallback(function (index) {
        var newGroups = groups.filter(function (_, i) { return i !== index; });
        if (newGroups.length === 0) newGroups = [createGroup('AND')];
        handleGroupsChange(newGroups);
    }, [groups, handleGroupsChange]);

    var handleAddGroup = useCallback(function () {
        if (groups.length >= maxGroups) return;
        handleGroupsChange(groups.concat([createGroup('OR')]));
    }, [groups, maxGroups, handleGroupsChange]);

    // ─── Convert to AntCondition format ──────────────────────────
    var toCondition = useCallback(function () {
        var condition = {};
        groups.forEach(function (group, gi) {
            var groupCondition = {};
            group.rules.forEach(function (rule) {
                if (!rule.field) return;
                if (NO_VALUE_OPS.includes(rule.operator)) {
                    groupCondition[rule.field] = rule.operator;
                } else if (rule.operator === '=' || rule.operator === 'in') {
                    var val = rule.operator === 'in' ? rule.value.split(',').map(function (s) { return s.trim(); }) : rule.value;
                    groupCondition[rule.field] = val;
                } else {
                    groupCondition[rule.field] = { type: rule.operator, value: rule.value };
                }
            });
            if (groups.length === 1) {
                condition = groupCondition;
            } else {
                condition['group' + gi] = { when: groupCondition };
            }
        });
        if (groups.length > 1) condition.whenType = 'AND';
        return condition;
    }, [groups]);

    // ─── Expose ref methods ──────────────────────────────────────
    useImperativeHandle(ref, function () {
        return {
            getGroups: function () { return groups; },
            setGroups: function (g) { setGroups(g); },
            toCondition: toCondition,
            validate: function () {
                var hasEmpty = false;
                groups.forEach(function (g) {
                    g.rules.forEach(function (r) {
                        if (!r.field) hasEmpty = true;
                        if (!NO_VALUE_OPS.includes(r.operator) && !r.value && r.value !== 0) hasEmpty = true;
                    });
                });
                return !hasEmpty;
            },
            reset: function () { setGroups([createGroup('AND')]); }
        };
    });

    // ─── Preview ─────────────────────────────────────────────────
    var previewText = useMemo(function () {
        if (!showPreview) return '';
        return groups.map(function (group) {
            var parts = group.rules.filter(function (r) { return r.field; }).map(function (r) {
                var fieldCfg = fields.find(function (f) { return f.dataField === r.field; });
                var fieldLabel = fieldCfg ? (typeof fieldCfg.label === 'object' ? t(fieldCfg.label) : fieldCfg.label) : r.field;
                if (NO_VALUE_OPS.includes(r.operator)) return fieldLabel + ' ' + r.operator;
                return fieldLabel + ' ' + r.operator + ' ' + r.value;
            });
            return parts.join(' ' + group.type + ' ');
        }).filter(Boolean).join(' AND ');
    }, [groups, fields, showPreview]);

    // ─── Visibility check (after all hooks) ──────────────────────
    if (visible && session && !AntCondition.checkAll({}, visible, session)) return null;

    // ─── Render ──────────────────────────────────────────────────
    return (
        <div className={'ant-rule-builder' + (compact ? ' compact' : '') + (readOnly ? ' readonly' : '')}>
            {title && (
                <div className="rule-builder-title">
                    {typeof title === 'object' ? t(title) : title}
                </div>
            )}

            <div className="rule-builder-body">
                {groups.map(function (group, gi) {
                    return (
                        <div key={group.id} className="rule-builder-group-wrap">
                            {gi > 0 && <div className="group-connector">AND</div>}
                            <RuleGroup
                                group={group}
                                fields={fields}
                                onChange={function (updated) { handleGroupChange(gi, updated); }}
                                onRemove={function () { handleGroupRemove(gi); }}
                                readOnly={readOnly}
                                level={0}
                            />
                        </div>
                    );
                })}

                {!readOnly && groups.length < maxGroups && (
                    <button className="add-group-btn" onClick={handleAddGroup}>
                        + {t({ vi: 'Thêm nhóm điều kiện', en: 'Add condition group', fr: 'Groupe de conditions', es: 'Grupo de condiciones', id: 'Grup kondisi', ja: '条件グループ', zh: '条件组', ko: '조건 그룹', hi: 'शर्त समूह', ar: 'مجموعة شروط' })}
                    </button>
                )}
            </div>

            {showPreview && previewText && (
                <div className="rule-preview">
                    <span className="preview-label">{t({ vi: 'Xem trước:', en: 'Preview:', fr: 'Aperçu :', es: 'Vista previa:', id: 'Pratinjau:', ja: 'プレビュー:', zh: '预览:', ko: '미리보기:', hi: 'पूर्वावलोकन:', ar: 'معاينة:' })}</span>
                    <span className="preview-text">{previewText}</span>
                </div>
            )}
        </div>
    );
});
